<form name="BranchHolidayForm" (ngSubmit)="SaveBranchHoliday()" #BranchHolidayForm="ngForm">
    <div class="pt-2">
        <div class="card">
            <div class="card-header">
                <div class="card-title">Branch Holiday Mapping</div>
            </div>

            <div class="m-2 card-body">
                <form name="BranchHolidayFilterForm" (ngSubmit)="Validate(BranchHolidayFilterForm)"
                    #BranchHolidayFilterForm="ngForm" class="pb-2">
                    <div class="row">
                        <div class="col-md-2  px-1">
                            <label>Year</label>
                            <select name="Year" class="form-control form-select" [(ngModel)]="filter.Year"
                                #Year="ngModel" (ngModelChange)="ClearHolidays()" required
                                [disabled]="DisablesFilter.Year">
                                <option [value]=null disabled hidden>Select Year</option>
                                <option *ngFor="let Year of Years" [value]="Year">
                                    {{Year}}
                                </option>

                            </select>
                            <div class="invalid-feedback">
                                Please select year!
                            </div>

                        </div>
                        <div class="col-md-5  px-1">

                            <label>Branch</label>
                            <ng-select name="BranchId" (change)="ClearHolidays()" [(ngModel)]="filter.BranchId"
                                #BranchId="ngModel" required [disabled]="DisablesFilter.Year"
                                placeholder="Select Branch">
                                <ng-option *ngFor="let Branch of Branchs"
                                    [value]="Branch.BranchMasterID">{{Branch.BranchName}}</ng-option>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select branch!
                            </div>

                        </div>
                        <div class="col-md-1 px-1 pt-4">
                            <button type="submit" class="btn btn-primary text-nowrap" [disabled]="isDisabled">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Get Holiday':'Loading...'}}</button>

                        </div>
                    </div>
                </form>
                <div class="row">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th>Holiday Name</th>
                                <th style="width: 150px">Date</th>
                                <th style="width: 250px;">Not Applicable/Compulsory/Optional</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let element of HolidayData">
                                <td>{{element['HolidayName']}}</td>
                                <td style="width: 150px">{{element['Date']}}</td>
                                <td style="width: 250px;">
                                    <select name="TypesOfLeave_{{element['ESS_CompanyHolidayMasterId']}}"
                                        [(ngModel)]="element['TypesOfLeave']" required>
                                        <option *ngFor="let type of TypesOfLeaves" [value]="type">
                                            {{type}}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
            <div class="card-footer">
                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                        (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Cancel':'Loading...'}}</button>

                    <button
                        *ngIf="(this.common.PageRight.IsAdd && this.filter.BranchId == 0) || (this.common.PageRight.IsEdit && this.filter.BranchId > 0)"
                        type="submit" class="btn btn-primary text-nowrap" [disabled]="isDisabled"><i class="bi bi-save"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</form>